import React from "react";

function ForceCronDialog({ job, busy, error, onCancel, onConfirm }) {
  if (!job) return null;

  return (
    <div className="cron-force-overlay flex items-center justify-center pa3" role="presentation">
      <div
        className="cron-force-dialog sfondoBiancoTema br3 pa4 shadow-5 w-100"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cron-force-title"
      >
        <div className="flex items-start">
          <span className="material-icons f2 dark-orange mr3" aria-hidden="true">
            play_circle
          </span>
          <div>
            <h3 id="cron-force-title" className="mt0 mb2">
              Avviare {job.label}?
            </h3>
            <p className="mt0 mb2">
              Il processo verrà avviato subito e non potrà sovrapporsi a un'altra
              esecuzione nello stesso processo applicativo.
            </p>
            {job.scheduleLabel ? (
              <p className="f7 scrittaColMedia mt0">
                Pianificazione ordinaria: {job.scheduleLabel}
              </p>
            ) : null}
          </div>
        </div>

        {error ? (
          <div className="pa2 br2 ba dark-red mt3" role="alert">
            {error}
          </div>
        ) : null}

        <div className="flex justify-end mt4">
          <button
            type="button"
            className="button-reset ba br2 pa2 ph3 mr2 sfondoBiancoTema pointer"
            onClick={onCancel}
            disabled={busy}
          >
            Annulla
          </button>
          <button
            type="button"
            className="button-reset bn br2 pa2 ph3 tastoArancio white pointer"
            onClick={onConfirm}
            disabled={busy}
          >
            <span className="material-icons f5 mr2 v-mid" aria-hidden="true">
              play_arrow
            </span>
            {busy ? "Avvio..." : "Avvia ora"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ForceCronDialog;
